/**
 * Was die Orbit-Seite zeigt. Wie auf der Space-Seite festgelegt, keine API.
 *
 * Alle Fotos sind von Sebastian Laube (wie auf der Startseite). Ein Orbit
 * braucht aber andere Menschen; deren Namen sind ausgedacht, die Zahlen und
 * Kommentare Beispiele. Echte Konten zu zeigen hiesse, Namen und Bilder ohne
 * Einverstaendnis auszustellen.
 */

const LP = 'assets/img/lp/';

export const CAMELS = 'assets/img/features/space-camels.webp';

/** Der Urheber, aus dessen Sicht die Seite erzaehlt: das Konto des Betreibers. */
export const OWNER = 'sLaube';

/**
 * Die anderen, im Muster der Namen, die Anchoria neuen Konten gibt
 * („anchor-“ + sechs Zeichen, handlers/passkey.go). Dort sind es nur
 * Hex-Ziffern; hier steckt in jedem ein Buchstabe jenseits von f — so kann
 * keiner davon je einem echten, automatisch benannten Konto gehoeren.
 * Die Schluessel sind nur Namen im Code.
 */
export const DEMO = { lena: 'anchor-8w7djh', jonas: 'anchor-k2m9qx', mika: 'anchor-r5t1wz' };

/** Aufnahmedaten des Kamel-Fotos (wie auf der Space-Seite, aus dem Original). */
export const CAMEL_EXIF = {
  camera: 'Canon EOS 7D',
  lens: 'EF50mm f/1.8 STM',
  focal: '50',
  aperture: 'f/1.8',
  iso: '100',
  shutter: '1/8000',
  taken: '28.11.2018',
};
export const CAMEL_TAGS = ['küste', 'camel', 'desert', 'animal'];

/** Der eigene Space vor dem Veroeffentlichen: alles zu. Das Kamel vorn. */
export const OWN_VISUALS = [
  CAMELS, LP + 'lp-pod-7.webp', LP + 'lp-pod-11.webp', LP + 'lp-pod-5.webp',
  LP + 'lp-pod-1.webp', LP + 'lp-pod-12.webp', LP + 'lp-pod-8.webp', LP + 'lp-pod-4.webp',
];

/**
 * Der Orbit. Das erste Feld ist frei fuer das Kamel, das in der Szene
 * hereinkommt; der Rest sind Visuals der Demo-Konten.
 */
export const ORBIT = [
  { image: LP + 'lp-hero-2.webp', user: DEMO.lena, likes: 11, comments: 2 },
  { image: LP + 'lp-pod-6.webp', user: DEMO.jonas, likes: 7, comments: 0 },
  { image: LP + 'lp-hero-3.webp', user: DEMO.mika, likes: 4, comments: 1 },
  { image: LP + 'lp-pod-9.webp', user: DEMO.lena, likes: 9, comments: 0 },
  { image: LP + 'lp-pod-2.webp', user: DEMO.jonas, likes: 3, comments: 0 },
  { image: LP + 'lp-hero-4.webp', user: DEMO.mika, likes: 6, comments: 2 },
  { image: LP + 'lp-pod-10.webp', user: DEMO.lena, likes: 2, comments: 0 },
];

/** Das Visual von DEMO.lena, auf das in „Reagieren“ geantwortet wird. */
export const LENA_VISUAL = LP + 'lp-hero-2.webp';
export const LENA_LIKES = 11;

/** Was DEMO.lena im Profil zeigt — ihre oeffentlichen Visuals. */
export const LENA_PROFILE = [
  LP + 'lp-hero-2.webp', LP + 'lp-pod-9.webp', LP + 'lp-pod-10.webp',
  LP + 'lp-pod-3.webp', LP + 'lp-hero-1.webp', LP + 'lp-pod-12.webp',
];

/** Das gemeldete Visual (DEMO.mika). */
export const MIKA_VISUAL = LP + 'lp-hero-3.webp';

/**
 * Aktenzeichen im Format der API (utils.ReportRef: „AR-%06d“). Die Nummer ist
 * ein Beispiel.
 */
export const REPORT_REF = 'AR-000042';
